import { useSelector } from 'react-redux'
import { StoreState } from '@/store'
import { isSSR, isMobile as isMobileFun } from '@/utils/is'

const useIsMobile = () => {
  const { isMobile } = useSelector((state: StoreState) => state.ssr)

  if (!isSSR && window?.navigator.userAgent) {
    return isMobileFun(window?.navigator.userAgent)
  }
  return isMobile
}

export default useIsMobile
